import { EigBaseComponent } from '@eightcap/ui/eig-base/eig-base.component';
import { SessionService } from '@core/services/session.service';
import { OnInit, Directive } from '@angular/core';
import Helper from '@core/helper/common.helper';
import { ActionRole, ModulePermission } from '@modules/auth/models/user-auth.model';

/**
 * Base class for components which provides a list view for one API source.
 * If the page component needs to show more than one list views,
 * implement two list components that inherit this base class
 */
@Directive()
// tslint:disable-next-line: directive-class-suffix
export abstract class EigBaseAdminComponent extends EigBaseComponent implements OnInit {

    permission_list: ModulePermission[];
    actionRole: ActionRole;

    protected constructor(
        protected sessionService: SessionService
    ) {
        super();
        this.actionRole = this.configureActionRole();
    }

    ngOnInit(): void {
        this.permission_list = Helper.getListPermission(this.sessionService, this.adminModule);

        if (this.permission_list.length) {
            const actions = this.permission_list[0].actions;
            this.actionRole = actions ? Helper.getRoleList(actions) : this.actionRole;
        }
    }

    protected configureActionRole(): ActionRole {
        return new ActionRole(true, true, true, true, true, true, true);
    }

}
